export interface BlockStyle {
  fontSize: number;
  /**
   * Measured size in points. When set, preview CSS and the PDF use this value
   * directly so a px step cannot change the printed size.
   */
  fontSizePt?: number;
  fontWeight: 'normal' | 'bold';
  /** CSS weight 100–900. When set, preview and PDF use it instead of normal/bold. */
  fontWeightValue?: number;
  textAlign: 'left' | 'center' | 'right';
  textColor: string;
  backgroundColor: string;
  paddingY: number;
  borderTop: boolean;
  borderBottom: boolean;
  italic?: boolean;
  uppercase?: boolean;
  /** Editor preview pane height (pixels); persisted per block version. */
  previewHeight?: number;
  /** CSS family for this block. Absent inherits the template base font. */
  fontFamily?: string;
  /** Rule color when borderTop or borderBottom is set. Absent keeps the accent/muted default. */
  borderColor?: string;
}

export const DEFAULT_BLOCK_STYLE: BlockStyle = {
  fontSize: 14,
  fontWeight: 'normal',
  textAlign: 'left',
  // Use design-token CSS variables (resolved by the host/theme at render time).
  textColor: 'var(--rdb-text-color)',
  backgroundColor: 'var(--rdb-bg-color)',
  paddingY: 8,
  borderTop: false,
  borderBottom: false
};
